module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<td>\n  <label for="compteur.code" class="required">&nbsp;</label>\n  <span class="cmbCompteur"></span>\n</td>\n<td>\n  <label for="typeresultat.code" class="required">&nbsp;</label>\n  <span class="cmbTypeRes"></span>\n</td>\n<td>\n  <label for="periodicite.code" class="required">&nbsp;</label>\n  <span class="cmbPeriodicite"></span>\n</td>\n<td>\n  <label for="periodevalo.code" class="required">&nbsp;</label>\n  <span class="cmbPeriodeValo"></span>\n</td>\n<td>\n  <!-- 	<label for="format">&nbsp;</label> -->\n  <span class="format"></span>\n</td>';
}
return __p;
};
